import {
  Mixins,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import pageMixin from '../../../../mixins/pageMixin';

@Component
export default class listMixin extends Mixins(pageMixin) {
  @Prop({
    default: false,
    required: true,
  }) worksData!: boolean;
}
